import { mediaQuery } from "../utils/media-query";
import { $Q, $Qll } from "../utils/query-selector";

/**
 * Validate in the URL if there is filter applied of price.
 * If It is false remove default value in filter price
 * It if true continuos
 * For mobile devices
 */
const initValues = () => {
  const MIN_INPUT_NAME = 'filter.v.price.gte'
  const MAX_INPUT_NAME = 'filter.v.price.lte'
  const pricein = $Qll(".price-in input");
  const url = new URLSearchParams(window.location.search)

  if (!url.get(MIN_INPUT_NAME) || !url.get(MAX_INPUT_NAME)) {
    pricein.forEach(input => {
      input.removeAttribute('value')
    })
  }

}

/**
 *
 * we control the price range filter in order to avoid that the minimum
 * value is greater than the highest value and that the highest
 * value is not less than the lowest value
 *
 */
export function rangeFilters() {
  const rangein = $Qll(".range-in input");
  const pricein = $Qll(".price-in input");
  const progress = $Q('.slider-filter .pro');
  const priceGap = 0;

  // Init values in mobile devices
  mediaQuery('(max-width: 767px)', initValues)

  rangein.forEach(input => {
    if (rangein[0].value) {
      progress.style.left = (rangein[0].value / rangein[0].max) * 100 + "%";
      progress.style.right = 100 - (rangein[1].value / rangein[1].max) * 100 + "%";
    }

    input.addEventListener("input", (e) => {
      const minVal = Number(rangein[0].value);
      const maxVal = Number(rangein[1].value);

      if(maxVal - minVal < priceGap){
        // Reset each input range individually
        if(e.target.className === "range-min") {
          rangein[0].value = priceGap;
          pricein[0].value = cents(priceGap, true);
          progress.style.left = (priceGap / rangein[0].max) * 100 + "%";
        } else {
          rangein[1].value = rangein[1].max;
          pricein[1].value = cents(rangein[1].max, true);
          progress.style.right = 100 - (rangein[1].max) * 100 + "%";
        }
      } else if (minVal === maxVal) {
        // Reset values if these are equals
          rangein[0].value = priceGap;
          rangein[1].value = rangein[1].max;
          pricein[0].value = cents(priceGap, true);
          pricein[1].value = cents(rangein[1].max, true);
          progress.style.left = (priceGap / rangein[0].max) * 100 + "%";
          progress.style.right = 100 - (rangein[1].max) * 100 + "%";
      } else {
        // Expected behavior
        pricein[0].value = cents(minVal, true);
        pricein[1].value = cents(maxVal, true);
        progress.style.left = (minVal / rangein[0].max) * 100 + "%";
        progress.style.right = 100 - (maxVal / rangein[1].max) * 100 + "%";
      }
    });
  });
}

export function cents(str, fixed) {
  const number = Number(str) / 100
  if (fixed) return number.toFixed(0);
  return number
}
